<div class="mobileFilter">
    <div class="filterHeader">
        <div class="filterTitle">
            <div class="back mr10">
                <div class="backInco" (click)="back()"></div>
            </div>{{'inquiry.ticketFilter' | translate}}
        </div>
    </div>
    <div class="filterSearch"></div>
    <form nz-form class="ant-advanced-search-form pd20">
        <div nz-row [nzGutter]="24">
            <div nz-col [nzSpan]="24">
                <div class="labelInfo">
                    <div class="labelName">{{'ticket.ticketNo' | translate}}</div>
                    <div>
                        <nz-radio-group [(ngModel)]="isDescTicketNo" [ngModelOptions]="{standalone: true}"
                            (ngModelChange)="radioSelect('ticketNo')">
                            <label nz-radio nzValue="true">{{'radio.alphabeticalA' | translate}}</label>
                            <label nz-radio nzValue="false">{{'radio.alphabeticalZ' | translate}}</label>
                        </nz-radio-group>
                    </div>
                </div>
            </div>
        </div>
        <div nz-row [nzGutter]="24" class="mt10" *ngIf="isSupport">
            <div nz-col [nzSpan]="24">
                <div class="labelInfo">
                    <div class="labelName">{{'ticket.fullName' | translate}}</div>
                    <div>
                        <nz-radio-group [(ngModel)]="isDescSubmittedBy" [ngModelOptions]="{standalone: true}"
                            (ngModelChange)="radioSelect('fullName')">
                            <label nz-radio nzValue="true">{{'radio.alphabeticalA' | translate}}</label>
                            <label nz-radio nzValue="false">{{'radio.alphabeticalZ' | translate}}</label>
                        </nz-radio-group>
                    </div>
                </div>
            </div>
        </div>
        <div nz-row [nzGutter]="24" class="mt10" >
            <div nz-col [nzSpan]="12">
                <div class="labelInfo">
                    <div class="labelName">{{'ticket.submittedDate' | translate}}</div>
                    <div>
                        <nz-date-picker [(ngModel)]="submittedDateStart" [ngModelOptions]="{standalone: true}"
                            class="fullWidth" nzPlaceHolder="Start"></nz-date-picker>
                    </div>

                </div>
            </div>
            <div nz-col [nzSpan]="12" class="mt22">
                <div class="labelInfo">
                    <div>
                        <nz-date-picker [(ngModel)]="submittedDateEnd" [ngModelOptions]="{standalone: true}"
                            nzPlaceHolder="end" class="fullWidth"> </nz-date-picker>
                    </div>
                </div>
            </div>
            <div nz-col [nzSpan]="24">
                <div class="labelInfo">
                    <nz-radio-group [(ngModel)]="isDescSubmittedDate" [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="radioSelect('submittedDate')">
                        <label nz-radio nzValue="true">{{'radio.chronologicalOrder' | translate}}</label>
                        <label nz-radio nzValue="false">{{'radio.reverseOrder' | translate}}</label>
                    </nz-radio-group>
                </div>
            </div>
           
        </div>
        <div nz-row [nzGutter]="24" class="mt10">
            <div nz-col [nzSpan]="24">
                <div class="labelInfo">
                    <div class="labelName">{{'ticket.status' | translate}}</div>
                    <div>
                        <nz-checkbox-group [(ngModel)]="ticketStatusList"
                            [ngModelOptions]="{standalone: true}"></nz-checkbox-group>
                    </div>
                </div>
            </div>
        </div>
        <div nz-row [nzGutter]="24" class="mt10">
            <div nz-col [nzSpan]="24">
                <div class="labelInfo">
                    <div class="labelName">{{'ticket.problemCategory' | translate}}</div>
                    <div>
                        <nz-checkbox-group [(ngModel)]="problemCategoryList"
                            [ngModelOptions]="{standalone: true}"></nz-checkbox-group>
                    </div>
                </div>
            </div>
        </div>
        <div nz-row [nzGutter]="24" class="mt10" *ngIf="isSupport">
            <div nz-col [nzSpan]="24">
                <div class="labelInfo">
                    <div class="labelName">{{'ticket.assignedTeam' | translate}}</div>
                    <div>
                        <nz-checkbox-group [(ngModel)]="supportTeamList"
                            [ngModelOptions]="{standalone: true}"></nz-checkbox-group>
                    </div>
                </div>
            </div>
        </div>


        <div nz-row [nzGutter]="24" class="mt10" *ngIf="isSupport">
            <div nz-col [nzSpan]="24">
                <div class="labelInfo">
                    <div class="labelName">{{'ticket.acceptBy' | translate}}</div>
                    <div>
                        <nz-radio-group [(ngModel)]="isDescAcceptedBy" [ngModelOptions]="{standalone: true}"
                            (ngModelChange)="radioSelect('acceptBy')">
                            <label nz-radio nzValue="true">{{'radio.alphabeticalA' | translate}}</label>
                            <label nz-radio nzValue="false">{{'radio.alphabeticalZ' | translate}}</label>
                        </nz-radio-group>
                    </div>
                    <div>
                        <nz-input-group>
                            <input type="text" [(ngModel)]="acceptedBy" nz-input placeholder="Search acceptBy"  [ngModelOptions]="{standalone: true}" 
                           />
                            </nz-input-group>
                    </div>
                </div>
            </div>
        </div>

        <div nz-row [nzGutter]="24" class="mt10" *ngIf="isSupport">
            <div nz-col [nzSpan]="12">
                <div class="labelInfo">
                    <div class="labelName">{{'ticket.acceptDate' | translate}}</div>
                    <div>
                        <nz-date-picker [(ngModel)]="acceptDateStart" [ngModelOptions]="{standalone: true}"
                            class="fullWidth" nzPlaceHolder="Start"></nz-date-picker>
                    </div>

                </div>
            </div>
            <div nz-col [nzSpan]="12" class="mt22">
                <div class="labelInfo">
                    <div>
                        <nz-date-picker [(ngModel)]="acceptDateEnd" [ngModelOptions]="{standalone: true}"
                            nzPlaceHolder="end" class="fullWidth"> </nz-date-picker>
                    </div>
                </div>
            </div>
            <div nz-col [nzSpan]="24">
                <div class="labelInfo">
                    <nz-radio-group [(ngModel)]="isDescAcceptedDate" [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="radioSelect('acceptedDate')">
                        <label nz-radio nzValue="true">{{'radio.chronologicalOrder' | translate}}</label>
                        <label nz-radio nzValue="false">{{'radio.reverseOrder' | translate}}</label>
                    </nz-radio-group>
                </div>
            </div>
        </div>

        <div nz-row [nzGutter]="24" class="mt10" *ngIf="isSupport">
            <div nz-col [nzSpan]="24">
                <div class="labelInfo">
                    <div class="labelName">{{'ticket.closedBy' | translate}}</div>
                    <div>
                        <nz-radio-group [(ngModel)]="isDescClosedBy" [ngModelOptions]="{standalone: true}"
                            (ngModelChange)="radioSelect('closedBy')">
                            <label nz-radio nzValue="true">{{'radio.alphabeticalA' | translate}}</label>
                            <label nz-radio nzValue="false">{{'radio.alphabeticalZ' | translate}}</label>
                        </nz-radio-group>
                    </div>
                </div>
            </div>
        </div>

        <div nz-row [nzGutter]="24" class="mt10" *ngIf="isSupport">
            <div nz-col [nzSpan]="12">
                <div class="labelInfo">
                    <div class="labelName">{{'ticket.acceptDate' | translate}}</div>
                    <div>
                        <nz-date-picker [(ngModel)]="closedDateStart" [ngModelOptions]="{standalone: true}"
                            class="fullWidth" nzPlaceHolder="Start"></nz-date-picker>
                    </div>

                </div>
            </div>
            <div nz-col [nzSpan]="12" class="mt22">
                <div class="labelInfo">
                    <div>
                        <nz-date-picker [(ngModel)]="closedDateEnd" [ngModelOptions]="{standalone: true}"
                            nzPlaceHolder="end" class="fullWidth"> </nz-date-picker>
                    </div>
                </div>
            </div>
            <div nz-col [nzSpan]="24">
                <div class="labelInfo">
                    <nz-radio-group [(ngModel)]="isDescClosedDate" [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="radioSelect('closedDate')">
                        <label nz-radio nzValue="true">{{'radio.chronologicalOrder' | translate}}</label>
                        <label nz-radio nzValue="false">{{'radio.reverseOrder' | translate}}</label>
                    </nz-radio-group>
                </div>
            </div>
        </div>
        <div nz-row [nzGutter]="24" class="mt10">
            <div nz-col [nzSpan]="24">
                <button mat-raised-button color="primary" (click)="save()"> {{'button.save' | translate }}</button>
            </div>
        </div>
    </form>
</div>